import React from 'react';
import { useHistory } from 'react-router';
import { ChevronRight } from '@saleshandy/icons';

import { accessibleOnClick } from '../../../../../../shared/utils/accessible-on-click';

const PurchasePhoneNumberHeader: React.FC = () => {
  const history = useHistory();

  const onTitleClick = () => {
    history.push('/dialer/phone-numbers');
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="create-email-infrastructure-header d-flex align-items-center">
        <p
          className="create-email-infrastructure-header--title"
          {...accessibleOnClick(onTitleClick)}
        >
          Phone Numbers
        </p>
        <div className="create-email-infrastructure-header--icon d-flex justify-content-center align-items-center">
          <ChevronRight />
        </div>
        <p className="create-email-infrastructure-header--title">
          Purchase
        </p>
      </div>
    </div>
  );
};

export default PurchasePhoneNumberHeader;

